// ============================================================
// App.js - Main file that puts all sections together
// ============================================================

import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TaglineBanner from "./components/TaglineBanner";
import Stats from "./components/Stats";
import Highlights from "./components/Highlights";
import About from "./components/About";
import WhoWeServe from "./components/WhoWeServe";
import Services from "./components/Services";
import Galathiya from "./components/Galathiya";
import CTA from "./components/CTA";
import Footer from "./components/Footer";

import "./styles/Navbar.css";
import "./styles/Hero.css";
import "./styles/TaglineBanner.css";
import "./styles/Stats.css";
import "./styles/Highlights.css";
import "./styles/About.css";
import "./styles/WhoWeServe.css";
import "./styles/Services.css";
import "./styles/Galathiya.css";
import "./styles/CTA.css";
import "./styles/Footer.css";
import "./styles/Global.css";

function App() {
  return (
    <div>
      <Navbar />
      <Hero />
      <TaglineBanner />
      <Stats />
      <Highlights />
      <About />
      <WhoWeServe />
      <Services />
      <Galathiya />
      <CTA />
      <Footer />
    </div>
  );
}

export default App;
